import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_USER_GROUPS } from "./gql";

type UseGetUserGroupsProps = {
  id?: string;
};

const useGetUserGroups = ({ id }: UseGetUserGroupsProps) => {
  const { data, loading, error } = useQuery(GET_USER_GROUPS, {
    variables: {
      id: id!,
    },
    skip: !id,
  });

  const groups = useMemo(() => {
    if (!data) return undefined;

    const uniqueGroups = [
      ...new Set([...data.managedUser.latestGroups, ...data.managedUser.scimGroupMemberships]),
    ];

    return uniqueGroups.map((group) => {
      const mappedGroup = data.managedUserGroups.find((g) => g.groupName === group) || null;

      return {
        name: group,
        id: mappedGroup?.id || group,
        mapped: mappedGroup,
      };
    });
  }, [data]);

  return { groups, loading, error, user: data?.managedUser };
};

export default useGetUserGroups;
